import { useLocation } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';

const GA_ID = 'G-MSMX7Z62G1';
const SCRIPT_SRC = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;

function isGaLoaded() {
  return document.querySelector('script[src*="googletagmanager.com/gtag"]') !== null;
}

export function Analytics() {
  const location = useLocation();
  const initialized = useRef(false);

  useEffect(() => {
    // Không load GA khi ở trang admin
    if (location.pathname.startsWith('/admin')) {
      return;
    }

    // Khởi tạo GA một lần duy nhất
    if (!initialized.current) {
      window.dataLayer = window.dataLayer || [];
      // gtag.js must push the `arguments` object, not an array.
      // Pushing an array makes the command get ignored -> no /g/collect request.
      window.gtag = function gtag() {
        // biome-ignore lint: gtag.js requires the `arguments` object
        window.dataLayer?.push(arguments);
      };
      window.gtag('js', new Date());
      // Tự kiểm soát pageview cho SPA -> tắt page_view tự động
      window.gtag('config', GA_ID, { send_page_view: false });

      // Chỉ thêm script nếu chưa có (tránh duplicate / Strict Mode)
      if (!isGaLoaded()) {
        const script = document.createElement('script');
        script.async = true;
        script.src = SCRIPT_SRC;
        document.head.appendChild(script);
      }
      initialized.current = true;
    }

    // Mỗi lần đổi route: gửi event page_view (chuẩn GA4 cho SPA)
    window.gtag?.('event', 'page_view', {
      page_path: location.pathname,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname]);

  return null;
}
